import { createSlice } from "@reduxjs/toolkit";
import { LeaderboardThunk } from "../../middlewares/leaderboard";

const initialState = {
  loading: false,
  items: [],
  latestRequestId: null,
};

const leaderboardSlice = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(LeaderboardThunk.pending, (state, action) => {
        state.loading = true;
        state.latestRequestId = action.meta.requestId;
      })
      // Only the newest request may write: rapid level-tab switches fire
      // overlapping requests, and a stale one resolving last must not
      // overwrite the active tab's list.
      .addCase(LeaderboardThunk.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.items = Array.isArray(action.payload) ? action.payload : [];
        state.loading = false;
      })
      .addCase(LeaderboardThunk.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
      });
  },
});

export default leaderboardSlice.reducer;
